<template>
  <v-app-bar color="header">
    <v-app-bar-title>
      <v-img :src="logo" width="100"></v-img>
    </v-app-bar-title>
    <template v-slot:append>
      <SelectLanguage />
    </template>
  </v-app-bar>
</template>

<script>
import SelectLanguage from "./SelectLanguage.vue";
export default {
  components: {
    SelectLanguage
  },
  props: {
    logo: {
      type: String,
      default: 'https://images.myket.in.th/myket-logo.png'
    },
  },
};
</script>

<style scoped lang="scss">

</style>